export default __webpack_public_path__ + "static/bkrm-logo-en-dffecc4e70352c05c73dd95cc0942924.png";